import http from "@/api/request";
import type { LoginResult, MeResult } from "@/types/auth";

/** 登录参数 */
export interface LoginParams {
  username: string;
  password: string;
}

/** 用户登录 */
export const loginApi = (data: LoginParams) => {
  return http.post<LoginResult>("/auth/login", data);
};

/** 获取当前用户与权限 */
export const fetchMeApi = () => {
  return http.get<MeResult>("/auth/me");
};
